function validateEmail(email: string) {
    //const usernameOrEmailRegex = /^(?:[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}|[A-Za-z0-9._-]+)$/;
   const usernameOrEmailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    // if (email.length === 0) {
    //     return 'Email Address required!';
    // }
    // if (!usernameOrEmailRegex.test(email)) {
       
    //     return 'Invalid Email Address!';
    // }

    // return '';
    return !usernameOrEmailRegex.test(email)
}

function validateUsername(username: string) {
    if (username.length === 0) {
      return 'Username required!';
    }
    return '';
  }


  function validatePassword(password: string) {
    if (password.length === 0) {
      return 'Password required!';
    }
    return '';
  }

function validateInitialPassword(password: string): string[] {

    const errors: string[] = [];

    // Check if password is empty
    if (password.length === 0) {
        errors.push("Password required!");
    } else {
        // Check for basic password requirements
        if (password.length < 9) {
            errors.push("Password is not 8 characters long");
        }

        if (!/[A-Z]/.test(password)) {
            errors.push("Password should have least 1 uppercase letter");
        }

        if (!/[a-z]/.test(password)) {
            errors.push("Password should have at least 1 lowercase letter")
        }

        if (!/\d/.test(password)) {
            errors.push("Password should have at least 1 number");
        }

        const specialCharRegex = /[!@#$%^&*(),.?":{}|<>[\]\\'`~\-_=+;|]/g;

        // Check if the password contains at least 1 special character
        if (!specialCharRegex.test(password)) {
            errors.push("Password should have at least 1 special character (!, @, #, etc,");
        }


    }
    return errors;


}

export { validateEmail, validatePassword, validateInitialPassword, validateUsername };
